
export default {
    methods: {
        logout() {
            localStorage.clear();
            this.$router.push('/login')
        },
    }
}